/**
 * Downloads a blob as a file with the specified filename
 */
export const saveFile = (blob: Blob, filename: string): void => {
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

/**
 * Downloads text content as a file with the specified filename and MIME type
 */
export const saveTextFile = (
  content: string,
  filename: string,
  mimeType: string = "text/plain;charset=utf-8",
): void => {
  const blob = new Blob([content], { type: mimeType });
  saveFile(blob, filename);
};

/**
 * Downloads CSV content as a file with the specified filename
 */
export const saveCsvFile = (csvContent: string, filename: string): void => {
  saveTextFile(csvContent, filename, "text/csv;charset=utf-8;");
};

/**
 * Example usage of the saveFile helper functions
 * This demonstrates how to use the file download helpers

// Example 1: Save a simple text file
export const saveHelloWorldExample = (): void => {
  const blob = new Blob(["Hello, world!"], {
    type: "text/plain;charset=utf-8",
  });
  saveFile(blob, "hello-world.txt");
};

// Example 2: Save text content directly
export const saveTextExample = (): void => {
  saveTextFile("This is some text content", "example.txt");
};

// Example 3: Save CSV content
export const saveCsvExample = (): void => {
  const csvContent = "Name,Age,City\nJohn,25,New York\nJane,30,London";
  saveCsvFile(csvContent, "example.csv");
};

// Example 4: Save JSON data as a file
export const saveJsonExample = (): void => {
  const jsonData = { name: "John", age: 25, city: "New York" };
  const jsonString = JSON.stringify(jsonData, null, 2);
  saveTextFile(jsonString, "data.json", "application/json;charset=utf-8");
};
 */
